import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LayoutService } from 'src/app/shared/services/layout.service';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  today: any = Date.now();
  currentUrl: string;
  year: number = new Date().getFullYear();
  public version: string = packageJson.version;

  constructor(
    private router: Router,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe({
      next: response => {
        if (response instanceof NavigationEnd) {
          if (response.url != '/') {
            const urlSplitted = response.url.split('/');
            this.currentUrl =
              urlSplitted[2] == undefined ? '/' + urlSplitted[1] : '/' + urlSplitted[1] + '/' + urlSplitted[2];
          } else {
            this.currentUrl = '/dashboard';
          }

          if (this.currentUrl == '/dashboard') {
            this.layoutService.deletePath();
          }
        }
      },
    });
  }
}
